﻿export const TemplateStatuses = {
    ARCHIVED: "Archived",
    DRAFT: "Draft",
    PUBLISHED: "Published",
};